import { defineMessages } from "@formatjs/intl";

const PREFIX = "lms.guide03.preparations-slide";
export const messages = defineMessages({
  title: {
    id: `${PREFIX}.title`,
  },
  description: {
    id: `${PREFIX}.description`,
  },
  accordionItem1Title: {
    id: `${PREFIX}.accordion-item1.title`,
  },
  accordionItem1Description: {
    id: `${PREFIX}.accordion-item1.description`,
  },
  accordionItem2Title: {
    id: `${PREFIX}.accordion-item2.title`,
  },
  accordionItem2Description: {
    id: `${PREFIX}.accordion-item2.description`,
  },
  speakerLayoutModalTitle: {
    id: `${PREFIX}.speaker-layout-modal.title`,
  },
  speakerLayoutModalDescription: {
    id: `${PREFIX}.speaker-layout-modal.description`,
  },
  speakerLayoutModalSlide1Description: {
    id: `${PREFIX}.speaker-layout-modal.slide1.description`,
  },
  speakerLayoutModalSlide2TopText: {
    id: `${PREFIX}.speaker-layout-modal.slide2.topText`,
  },
  speakerLayoutModalSlide2BulletPoint1: {
    id: `${PREFIX}.speaker-layout-modal.slide2.bulletPoint1`,
  },
  speakerLayoutModalSlide2BulletPoint2: {
    id: `${PREFIX}.speaker-layout-modal.slide2.bulletPoint2`,
  },
  speakerLayoutModalSlide2BulletPoint3: {
    id: `${PREFIX}.speaker-layout-modal.slide2.bulletPoint3`,
  },
  speakerLayoutModalSlide2BulletPoint4: {
    id: `${PREFIX}.speaker-layout-modal.slide2.bulletPoint4`,
  },
  speakerLayoutModalSlide2BottomText: {
    id: `${PREFIX}.speaker-layout-modal.slide2.bottomText`,
  },
  mixingStageModalTitle: {
    id: `${PREFIX}.mixing-stage-modal.title`,
  },
  mixingStageModalDescription: {
    id: `${PREFIX}.mixing-stage-modal.description`,
  },
  monitoringLevelsModalTitle: {
    id: `${PREFIX}.monitoring-levels-modal.title`,
  },
  monitoringLevelsModalDescription: {
    id: `${PREFIX}.monitoring-levels-modal.description`,
  },
  mediaPlayerModalTitle: {
    id: `${PREFIX}.media-player-modal.title`,
  },
  mediaPlayerModalDescription: {
    id: `${PREFIX}.media-player-modal.description`,
  },
  audioInterfaceModalTitle: {
    id: `${PREFIX}.audio-interface-modal.title`,
  },
  audioInterfaceModalSlide1Description: {
    id: `${PREFIX}.audio-interface-modal.slide1.description`,
  },
  audioInterfaceModalSlide1Content: {
    id: `${PREFIX}.audio-interface-modal.slide1.content`,
  },
  audioInterfaceModalSlide2Description: {
    id: `${PREFIX}.audio-interface-modal.slide2.description`,
  },
  audioInterfaceModalSlide3Description: {
    id: `${PREFIX}.audio-interface-modal.slide3.description`,
  },
  softwareRequirementsOption1: {
    id: `${PREFIX}.software-requirements.option1`,
  },
  softwareRequirementsOption2: {
    id: `${PREFIX}.software-requirements.option2`,
  },
  softwareRequirementsOption3: {
    id: `${PREFIX}.software-requirements.option3`,
  },
  softwareRequirementsSlide1Title: {
    id: `${PREFIX}.software-requirements-slide.slide1.title`,
  },
  softwareRequirementsSlide1Description1: {
    id: `${PREFIX}.software-requirements-slide.slide1.description1`,
  },
  softwareRequirementsSlide1Description2: {
    id: `${PREFIX}.software-requirements-slide.slide1.description2`,
  },
  softwareRequirementsSlide1Description3: {
    id: `${PREFIX}.software-requirements-slide.slide1.description3`,
  },
  softwareRequirementsSlide2Title: {
    id: `${PREFIX}.software-requirements-slide.slide2.title`,
  },
  softwareRequirementsSlide2Description1: {
    id: `${PREFIX}.software-requirements-slide.slide2.description1`,
  },
  softwareRequirementsSlide2Description2: {
    id: `${PREFIX}.software-requirements-slide.slide2.description2`,
  },
  softwareRequirementsSlide3Title: {
    id: `${PREFIX}.software-requirements-slide.slide3.title`,
  },
  softwareRequirementsSlide3Description1: {
    id: `${PREFIX}.software-requirements-slide.slide3.description1`,
  },
  softwareRequirementsSlide3Image1: {
    id: `${PREFIX}.software-requirements-slide.slide3.image1`,
  },
  softwareRequirementsSlide3Image2: {
    id: `${PREFIX}.software-requirements-slide.slide3.image2`,
  },
});
